import MovingBorderMenu from "../Menu/MovingBorderMenu";
import $ from 'jquery';
import '../../../../node_modules/select2/dist/js/select2.full'
import '../../../../node_modules/select2/dist/css/select2.min.css'

export default class Settings {
    /**
     * Constructor.
     *
     * @return {Void}
     */
    constructor() {
        $(() => {
            $('.ops-js-clear-cache').on('click', this.clearCache);
            $('.ops-js-clear-revisions').on('click', this.clearRevisions);
            $('.opd-product-list-item-op-smart-theme3 .ops-button').on('click', this.smartThemeActivation);
            $(".enable-js, .enable-css").on("click", this.enableScriptsAndStyles);
            $('[name="opd_intl_tel_input"][type="checkbox"]').on('change', this.intlTelInputEnableCheck);
            $('[name="opd_intl_tel_input_selector"]').on('input', this.intlTelInputSelectorChange).on('blur', this.intlTelInputSelectorBlur);

            $('.ops-form-control--select2').each((index, node) => {
                let $node = $(node);

                $node.select2({
                    placeholder: $node.attr('data-placeholder') || '',
                    width: '100%',
                    minimumResultsForSearch: $node.is('.ops-form-control--select2-simple') ? -1 : undefined,
                });
            });
        });
    }

    /**
     * Clear cache button click event handler
     *
     * @param {Object} e
     * @returns {Void}
     */
    clearCache(e) {
        let $el = $(this);
        let url = $el.data('url');
        let confirmMessage = $el.data('confirm') || "Are you sure you want to delete OptimizePress cache?";

        if (confirm(confirmMessage)) {
            let nonce = null
                || (window.OP3 && OP3.Meta ? OP3.Meta.nonce : "")
                || (window.OpsScriptData && OpsScriptData.nonce ? OpsScriptData.nonce : "")
                || "";

            jQuery.ajax({
                url: url,
                method: 'post',
                data: { _wpnonce: nonce },
                success: function (response) {
                    if (response.status === 200) {
                        window.OPDashboard.Helpers.notify(response.data.message, "success");
                    } else {
                        window.OPDashboard.Helpers.notify(response.data.message, "error");
                    }
                },
                error: function () {
                    window.OPDashboard.Helpers.notify("Error occurred when clearing the cache.", "error");
                }
            });
        }

        e.preventDefault();
    }

    /**
     * Clear revisions button click event handler
     *
     * @param {Object} e
     * @returns {Void}
     */
    clearRevisions(e) {
        let $el = $(this);
        let url = $el.data('url');
        let confirmMessage = $el.data('confirm');

        if (confirm(confirmMessage)) {
            let nonce = null
                || (window.OP3 && OP3.Meta ? OP3.Meta.nonce : "")
                || (window.OpsScriptData && OpsScriptData.nonce ? OpsScriptData.nonce : "")
                || "";

            jQuery.ajax({
                url: url,
                method: 'post',
                data: { _wpnonce: nonce },
                success: function (response) {
                    if (response.status === 200) {
                        window.OPDashboard.Helpers.notify(response.data.message, "success");
                    } else {
                        window.OPDashboard.Helpers.notify(response.data.message, "error");
                    }
                },
                error: function () {
                    window.OPDashboard.Helpers.notify("Error occurred when clearing revisions.", "error");
                }
            });
        }

        e.preventDefault();
    }

    /**
     * Smart theme activation button click event handler
     *
     * @param {Object} e
     * @returns {Void}
     */
    smartThemeActivation(e) {
        let opsButton = $(e.target);
        if (opsButton.hasClass("ops-transparent") || opsButton.hasClass("opd-button-install"))
            return;

        e.preventDefault();
        let dialogOptions = window.OP3General.dialogOptions;
        window.OP3General.confirm(
            Object.assign(dialogOptions, {
                theme: 'optimizepress,optimizepress-mini',
                title: 'Smart Theme v3',
                content: () => {
                    return '<p>Are you sure you want to activate Optimizepress Smart Theme v3? This will deactivate you current active WordPress theme.</p>'
                },
                buttons: {
                    confirm: {
                        text: "Confirm",
                        btnClass: 'btn-green',
                        action: function() {
                            let href = opsButton.attr("href");
                            window.location.href = href;
                        }
                    },
                    cancel: {
                        text: "Cancel",
                    }
                }
            })
        );
    }

    /**
     * Enable scripts and styles table header (js and css) click event handler
     *
     * @param {Object} e
     * @return {Void}
     */
    enableScriptsAndStyles(e) {
        var $target = $(e.target);
        var attr = $target.attr("data-type");
        var $inputs = $target
            .closest("table")
            .find("input[name*='" + attr + "']");

        $inputs.prop("checked", !$inputs.prop("checked"));
    }

    /**
     * International Telephone Input enable checkbox change event handler.
     *
     * We're hiding selector input on unchecked checkbox, so let's make sure
     * that the selector input is not invalid: this will cause "An invalid
     * form control is not focusable." exception on submit.
     *
     * TL;DR:
     * If selector input's validity is valid do not allow unchecked checkbox.
     *
     * @param  {Event} e
     * @return {Void}
     */
    intlTelInputEnableCheck(e) {
        let $selector = $(e.target)
            .closest(".opui-item")
            .find('[name="opd_intl_tel_input_selector"]');
        if (e.target.checked || $selector.prop('validity').valid)
            return;

        e.target.checked = true;
        $selector.get(0).reportValidity();
    }

    /**
     * International Telephone Input selector change event handler.
     *
     * @param  {Event} e
     * @return {Void}
     */
    intlTelInputSelectorChange(e) {
        try {
            if (e.target.value.trim() !== '')
                document.createDocumentFragment().querySelector(e.target.value);

            e.target.setCustomValidity('');
        } catch(ex) {
            e.target.setCustomValidity('Please enter valid CSS selector.');
        }
    }

    /**
     * International Telephone Input selector blur event handler.
     *
     * @param  {Event} e
     * @return {Void}
     */
    intlTelInputSelectorBlur(e) {
        if (e.target.value.trim() !== '')
            return;

        $(e.target)
            .val(e.target.getAttribute('data-default-value'))
            .trigger('input')
            .trigger('change');
    }
}
